<template>
  <v-col cols=12 sm=6 md=3>
    <v-card :loading="loading">
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text>
        <p v-for="(row, i) in data" :key="i">{{ row.title }}: <strong>{{ row.value }}</strong></p>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
export default {
  props: {
    'title': String,
    'route': String,
  },

  data() {
    return {
      'loading': true,
      'data': [],
    }
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      this.loading = true;

      axios.get('/api/developer/dashboard/'+this.route)
        .then(response => {
          this.data = response.data;
          this.loading = false;
        });
    },
  },
};
</script>
